export default __webpack_public_path__ + "static/media/icon-calendar.4d97cab6.svg";